<template>
    <div class="StockThresholdsPanel">
        <div class="stpTitle">{{ $t('stockPage.lists.sectionTitle') }}</div>
        <v-skeleton-loader v-if="!stock" type="image"></v-skeleton-loader>
        <div class="threshold" v-for="(e, i) in stockThresholds" :key="i">
            <StockThresholdPanel :stock="e"></StockThresholdPanel>
        </div>
    </div>
</template>

<script>
import UserListEntry from '../../models/UserListEntry';
import StockMixin from '../stocks/StockMixin';
import StockThresholdPanel from './StockThresholdPanel.vue';
export default {
    components: { StockThresholdPanel },
    mixins: [StockMixin],
    computed: {
        stockThresholds() {
            if (!this.$store.getters.allListAreLoaded) return []
            const x = Object.keys(this.$store.getters.userLists).reduce((acc, cur) => {
                if (cur !== 'portfolios') {
                    const lists = this.$store.getters.userLists[cur]
                    lists.forEach(list => {
                        const l = list.entries.find(s => s.stockId === this.stockId)
                        if (l) {
                            l.listName = list.name
                            l.listType = list.type
                            acc.push(l)
                        }
                        else {
                            const ule = new UserListEntry({ id: -1, stockId: this.stockId })
                            ule.listName = list.name
                            ule.listType = list.type
                            ule.listId = list.id
                            acc.push(ule)
                        }
                    })
                }

                // if (cur !== 'portfolios') {
                //     const lists = this.$store.getters.userLists[cur]
                //     lists.forEach(list => {
                //         list.entries.forEach(entry => {
                //             if (entry.stockId === this.stockId) {
                //                 entry.listName = list.name
                //                 entry.listType = list.type
                //                 acc.push(entry)
                //             }
                //         })
                //     })
                // }
                return acc
            }, [])
            return x
        }
    }
}
</script>

<style lang="scss" scoped>
.StockThresholdsPanel {
    display: flex;
    flex-direction: column;
    gap: 10px;
    border: solid 1px #FFF;
    padding: 10px;
    .stpTitle {
        font-size: 1.2em;
        font-weight: bold;
        color: #FFF;
    }
}
</style>